import {
  NarAgentGridData,
  NarAgentGridRemarkEntry,
} from "../data-model/medicalPaOrdersModel";

/** Get latest remark text: if remarks is array, sort by date desc and use latest; otherwise use string or "NA". */
export function getLatestRemarkText(
  remarks: NarAgentGridData["remarks"],
): string {
  if (remarks == null) return "NA";
  if (typeof remarks === "string") return remarks.trim() || "NA";
  if (!Array.isArray(remarks) || remarks.length === 0) return "NA";
  const sorted = [...remarks].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime(),
  );
  const latest = sorted[0] as NarAgentGridRemarkEntry;
  const text = latest?.remarks?.trim();
  return text !== undefined && text !== "" ? text : "NA";
}
